import axios from '../custom-axios';
import { SelectInput } from './select';
import { memo, useEffect, useState } from 'react';

export const BreedDropdown = memo(({
  value,
  type,
  handleBreedChange,
  handleBreedBlur,
}) => {
  const [breeds, setBreeds] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const headers = {
        'Api-Version': `${process.env.REACT_APP_API_VERSION}`,
        'Ocp-Apim-Subscription-Key': `${process.env.REACT_APP_SUBSCRIPTION_KEY}`
      };

      const response = await axios.processGet(
        `${process.env.REACT_APP_API_BASE_URL}/breeds`,
        { headers }
      )

      setBreeds(response.data.Data);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getReorderedBreedList = (type, updatedBreedList) => {
    const breed = type === 1 ? "Mixed Cat" : 'Mixed Dog'
    let i = 0;
    updatedBreedList.forEach((breedItem, index) => {
      if (breedItem.BreedName.includes(breed)) {
        updatedBreedList.splice(index, 1);
        updatedBreedList.splice(i, 0, breedItem);
        i += 1;
      }
    });
    return updatedBreedList;
  }

  const getBreedOptions = (type) => {
    const updatedBreedList = breeds
      .filter((breed) => breed.PetType === type)
      .map((breed) => ({ ...breed, label: breed.BreedName, value: breed.Id }))

    return getReorderedBreedList(type, updatedBreedList);
  }

  return (
    <SelectInput
      type='text'
      value={value}
      handleChange={handleBreedChange}
      handleBlur={handleBreedBlur}
      options={getBreedOptions(type)}
      isSearchable={true}
      placeholder={'Select a Breed'}
    />
  );
})
